// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yflKxLYnp2njVV7Pb0qV{line-height:1.5rem;margin-bottom:20px;flex:1 0 auto;position:relative;overflow:hidden}.XNYMLIFknOr5tUVEgdhr{text-align:center;color:var(--color-default);font-size:1rem;display:block;padding:5px;line-height:1.5rem}.XNYMLIFknOr5tUVEgdhr img{max-width:164px;max-height:28px;margin:8px 5px 0}.l1MEOB75pWGe7q8G808V{position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden}.l1MEOB75pWGe7q8G808V>img{width:100%;height:100%}.WVGMyOr5q89SEHPlsObw{height:100%;position:relative;margin-right:-12px}.WVGMyOr5q89SEHPlsObw .m2xznwtJKVoEsvA5P81c{display:flex;min-height:100%;flex-direction:column;justify-content:stretch}.IXx_mw2tAzSGad6YKo9Q .PqVN2DDTVLkSlEP0lNoc{display:flex}.IXx_mw2tAzSGad6YKo9Q .PqVN2DDTVLkSlEP0lNoc .L7lVLM5E7BKTLlG_V8Qq{padding:7px 0;flex:1 1 auto}.IXx_mw2tAzSGad6YKo9Q .Yas4yAhU1g3jQcQR30tA{margin-left:14px;margin-bottom:12px;margin-top:2px}.lY7KvZjWf8oRbMgLwsjy{flex:0 0 auto}.lY7KvZjWf8oRbMgLwsjy img{max-width:109px;width:100%;border-radius:5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"accordion": `yflKxLYnp2njVV7Pb0qV`,
	"collaboration": `XNYMLIFknOr5tUVEgdhr`,
	"content": `l1MEOB75pWGe7q8G808V`,
	"leftPanel": `WVGMyOr5q89SEHPlsObw`,
	"leftPanelWrapper": `m2xznwtJKVoEsvA5P81c`,
	"interviews": `IXx_mw2tAzSGad6YKo9Q`,
	"entry": `PqVN2DDTVLkSlEP0lNoc`,
	"text": `L7lVLM5E7BKTLlG_V8Qq`,
	"bioButtonWrapper": `Yas4yAhU1g3jQcQR30tA`,
	"videoThumb": `lY7KvZjWf8oRbMgLwsjy`
};
export default ___CSS_LOADER_EXPORT___;
